var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      class: [
        "biz-plan-input-readonly color-gray-9 yxtbizf-br-4 pt8 pl12",
        _vm.$slots.suffix ? "pr36" : "pr12",
        _vm.isTag ? "pb4" : "pb8",
        _vm.disabled ? "biz-plan-input-readonly__color" : "",
      ],
      on: {
        mouseenter: function ($event) {
          _vm.$slots.default && (_vm.hovering = true)
        },
        mouseleave: function ($event) {
          _vm.$slots.default && (_vm.hovering = false)
        },
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.placeholder && !_vm.$slots.default
        ? _c("div", { staticClass: "biz-plan-input-readonly__placholder" }, [
            _vm._v(_vm._s(_vm.placeholder)),
          ])
        : _vm._e(),
      _vm.$slots.default
        ? _c(
            "div",
            {
              staticClass: "biz-plan-input-readonly__content",
              class: _vm.isSupportWarp ? "text-nowrap" : "",
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      !_vm.clearable || (_vm.$slots.suffix && !_vm.hovering)
        ? _c(
            "div",
            { staticClass: "biz-plan-input-readonly__suffix" },
            [_vm._t("suffix")],
            2
          )
        : _c("div", { staticClass: "biz-plan-input-readonly__suffix" }, [
            _vm.clearable
              ? _c("i", {
                  staticClass:
                    "yxt-input__icon yxt-icon-error yxt-input__clear cursor-p",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      ;(_vm.hovering = false), _vm.$emit("clear")
                    },
                  },
                })
              : _vm._e(),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }